module.exports = __webpack_public_path__ + "static/growth.262439e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/growth.svg
// module id = 460
// module chunks = 226020273838829